import { ProductCodeRange } from './LeadProducts';
import { StatusCode } from './StatusCode';

export class SurveySimulationModel{
    Survey: number;
    SimulationStatus: StatusCode;
    SimulationId: number;
    SectionId: number;
    LastSectionDate?: Date|string;
    PersonId: number;
    PartnershipId: number;
    PartnerToken: string;
    ProductRange: ProductCodeRange;
    LastStepStartedId: number;
    StepTextFr: string;
    StepTextNl: string;
    StepStepOrder?: number;
    ChildFirstName?: string;
    PartnerSource?: string;
}

export interface InitiateSurveyModel{
    SurveyCode: number;
    FirstSectionId: number;
}
